import React, { FunctionComponent } from 'react';
import { Modal, ModalHeader, ModalFooter, ModalContent, ModalFooterButtons } from 'ui/molecules/modal';
import Translate from 'ui/atoms/translate';
import Hint from 'src/ui/atoms/hint';

export interface DeleteDocumentSuccessfulModalProps {
  onModalClose: () => void;
}

const DeleteDocumentSuccessfulModal: FunctionComponent<DeleteDocumentSuccessfulModalProps> = (props) => {
  const { onModalClose } = props;

  return (
    <Modal onClose={onModalClose}>
      <ModalHeader>
        <Translate name="successfulDeleteDocumentModal.title" />
      </ModalHeader>
      <ModalContent>
        <Hint variant="success">
          <Translate name="successfulDeleteDocumentModal.content" />
        </Hint>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'cancel',
              content: <Translate name="common.close" />,
              onClick: onModalClose,
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteDocumentSuccessfulModal;
